export default "__VITE_ASSET__CH1RbB3V__"